import { TRACKER_TYPES } from '../consts/trackers';

export type InsidersDeviceTypes =
  | TRACKER_TYPES.InsidersInspirit
  | TRACKER_TYPES.InsidersIntense
  | TRACKER_TYPES.InsidersSimulator;

export interface InsidersDevice {
  id: number;
  device_name: string;
  serial_number: string;
  device_type: string;
  firmware_version: string;
  custom_name: string;
}

export const isInsidersDeviceType = (deviceType: string): deviceType is InsidersDeviceTypes => {
  return (
    deviceType === TRACKER_TYPES.InsidersInspirit ||
    deviceType === TRACKER_TYPES.InsidersIntense ||
    deviceType === TRACKER_TYPES.InsidersSimulator
  );
};

export const filterInsidersDevicesByType = (
  devices: Array<InsidersDevice>,
  type: TRACKER_TYPES,
): Array<InsidersDevice> => {
  return devices.filter((device) => {
    switch (type) {
      case TRACKER_TYPES.InsidersInspirit:
        return device.device_type === 'Inspirit v1';
      case TRACKER_TYPES.InsidersIntense:
        return device.device_type === 'Intense v1';
      case TRACKER_TYPES.InsidersSimulator:
        return device.device_type === 'Simulator';
      default:
        return false;
    }
  });
};
